import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { LoaderComponent } from './components'
import { PrivateRoute, PublicRoute } from './routes'
import {
  APIPage,
  CardPage,
  DashboardPage,
  DebtPage,
  EmployeePage,
  ExpensePage,
  FuelImportPage,
  FuelPage,
  LoginPage,
  ProfilePage,
  PumpPage,
  PumpShiftPage,
  ReceiptPage,
  ShiftPage,
  StationPage,
  SupplierPage,
  TankPage,
  TransactionPage,
  UserPage,
  WorkSchedulePage,
} from './routes/pages'
import { RootState } from './stores'
import { loadProfile } from './stores/actions'

export const App: React.FC = () => {
  const dispatch = useDispatch()
  const { isProfileLoaded } = useSelector((state: RootState) => state.auth)

  React.useEffect(() => {
    if (!isProfileLoaded) {
      dispatch(loadProfile())
    }
    // eslint-disable-next-line
  }, [])

  if (!isProfileLoaded) {
    return <LoaderComponent />
  }

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path={['/']} component={DashboardPage} exact />
        <PrivateRoute path={['/apis']} component={APIPage} />
        <PrivateRoute path={['/users']} component={UserPage} />
        <PrivateRoute path={['/employees']} component={EmployeePage} />
        <PrivateRoute path={['/shifts']} component={ShiftPage} />
        <PrivateRoute path={['/work-schedules']} component={WorkSchedulePage} />
        <PrivateRoute path={['/pumps']} component={PumpPage} />
        <PrivateRoute path={['/transactions']} component={TransactionPage} />
        <PrivateRoute path={['/debts']} component={DebtPage} />
        <PrivateRoute path={['/receipts']} component={ReceiptPage} />
        <PrivateRoute path={['/expenses']} component={ExpensePage} />
        <PrivateRoute path={['/pump-shifts']} component={PumpShiftPage} />
        <PrivateRoute path={['/profile']} component={ProfilePage} />
        <PrivateRoute path={['/tanks']} component={TankPage} />
        <PrivateRoute path={['/stations']} component={StationPage} />
        <PrivateRoute path={['/cards']} component={CardPage} />
        <PrivateRoute path={['/suppliers']} component={SupplierPage} />
        <PrivateRoute path={['/fuels']} component={FuelPage} />
        <PrivateRoute path={['/fuel-imports']} component={FuelImportPage} />
        <PublicRoute path={['/login']} component={LoginPage} />
        <Route path={['*']} component={() => <Redirect to="/" />} />
      </Switch>
    </BrowserRouter>
  )
}
